//#region Libraries
import styled from "styled-components";
//#endregion

export const Stack = styled.section`
    & > ol {
        color: var(--red-3);
        font-size: 14px;
        line-height: 28px;
        list-style: none;
        padding: 0;
        margin: 0;
        overflow-y: auto;
        & li {
            padding-right: 10px;
        }
        &::-webkit-scrollbar {
            width: 8px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: var(--light-gray-4);
        }
        &::-webkit-scrollbar-track {
            background-color: var(--light-1);
        }
    }
    &.complete {
        background-color: var(--light-blue-2);
        border-radius: 8px;
        padding: 32px 24px;
        padding-right: 10px;
        & > ol {
            max-height: 40vh;
            @media (max-height: 650px) {
                max-height: 30vh;
            }
        }
    }
`;